export class ApplicationSettingsNotFoundError extends Error {
  constructor() {
    super(`Application settings not found`);
  }
}
